import { snakeToCamel } from './string-transformation.utils';

/**
 * Recursively converts all snake_case keys in an object or array of objects to camelCase.
 * @param data - The object or array of objects to transform.
 * @returns A new object or array of objects with camelCase keys.
 */
export const convertKeysToCamelCase = (data :any) :any => {
  if (Array.isArray(data)) {
    // If the input is an array, map over each item and convert its keys
    return data.map((item) => convertKeysToCamelCase(item));
  } else if (data !== null && typeof data === 'object') {
    // If the input is an object, convert its keys
    const newObj :any = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const newKey = snakeToCamel(key);
        newObj[newKey] = convertKeysToCamelCase(data[key]);
      }
    }

    return newObj;
  }
  // If the input is not an object or array, return it as is
  return data;
};
